import * as React from 'react'
import styled from 'styled-components'
import { animalColor, animalColorUiTheme } from 'global'
import { IHand, IProduct } from 'models'
import { Flex } from 'components'
import { Product } from './Product'

const ProductContainer = styled(Flex)<{ count: number }>`
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media screen and (min-width: 1012px) {
    display: grid;
    grid-template-columns: repeat(
      ${({ count }) => Math.min(count, 3)},
      minmax(250px, max-content)
    );
    grid-template-rows: minmax(min-content, max-content);
    justify-content: center;
    grid-gap: 8px;
    margin: 8px 0;
  }
`

interface IProductsFeedProps {
  hand: IHand
  products: IProduct[]
}

export const ProductsFeed = ({ hand, products }: IProductsFeedProps) => {
  return (
    <ProductContainer count={products.length}>
      {products.map((product, i) => (
        <Product
          key={product.id}
          product={product}
          animalColor={animalColor(hand.color)}
          animalUiTheme={animalColorUiTheme(hand.color)}
        />
      ))}
    </ProductContainer>
  )
}
